var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0135 13.5612L28.017 18.3917C27.983 18.8519 27.9391 19.3116 27.8855 19.7704C27.7957 20.5376 27.1721 21.1564 26.3889 21.244C23.9359 21.5181 21.3974 21.5181 18.9444 21.244C18.1612 21.1564 17.5376 20.5376 17.4478 19.7704C17.1548 17.265 17.1548 14.734 17.4478 12.2287C17.5376 11.4615 18.1612 10.8426 18.9444 10.7551C21.3974 10.4809 23.9359 10.4809 26.3889 10.7551C27.1721 10.8426 27.7957 11.4615 27.8855 12.2287C27.9373 12.6722 27.98 13.1164 28.0135 13.5612ZM22.6667 13.9995C21.5621 13.9995 20.6667 14.895 20.6667 15.9995C20.6667 17.1041 21.5621 17.9995 22.6667 17.9995C23.7712 17.9995 24.6667 17.1041 24.6667 15.9995C24.6667 14.895 23.7712 13.9995 22.6667 13.9995Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2048 8.05248C27.4121 8.4115 27.023 8.81352 26.611 8.76747C24.0104 8.47681 21.3229 8.47681 18.7223 8.76747C17.0298 8.95663 15.661 10.2894 15.4614 11.9964C15.1503 14.6561 15.1503 17.343 15.4614 20.0027C15.661 21.7097 17.0298 23.0424 18.7223 23.2316C21.3229 23.5222 24.0104 23.5222 26.611 23.2316C27.0258 23.1852 27.418 23.59 27.2087 23.9511C26.1706 25.7415 24.3198 26.9911 22.1691 27.2174L21.2999 27.3089C16.8854 27.7734 12.4329 27.7428 8.02519 27.2175L7.44927 27.1489C5.07311 26.8658 3.19037 25.0093 2.87388 22.6373C2.28602 18.2317 2.28602 13.7674 2.87388 9.36173C3.19037 6.98977 5.07311 5.1333 7.44927 4.85015L8.02519 4.78152C12.4329 4.25629 16.8854 4.22565 21.2999 4.69019L22.1691 4.78165C24.3216 5.00816 26.1695 6.25964 27.2048 8.05248Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBlack);
export default __webpack_public_path__ + "static/media/wallet-black.4c452b6c2b3e6c6055448ded8e5d9e1e.svg";
export { ForwardRef as ReactComponent };